import React, { forwardRef } from "react";
import type { FloatingContext } from "@floating-ui/react";

const ARROW_HEIGHT = 11;
const ARROW_WIDTH = 22;

interface Props {
  context: FloatingContext;
}

/**
 * CSS border-triangle for bottom placement only.
 * FloatingArrow's SVG flat-base stroke reads as a seam after 180° rotation.
 *
 * Positioning mirrors FloatingArrow: `bottom: 100%` anchors the arrow to the
 * top edge of the floating element; `left`/`top` come from arrow middleware.
 */
const TooltipArrowBottom = forwardRef<HTMLDivElement, Props>(({ context }, ref) => {
  const { x: arrowX, y: arrowY } = context.middlewareData.arrow ?? {};

  return (
    <div
      ref={ref}
      className="fuel-tooltip__arrow fuel-tooltip__arrow--css-bottom"
      aria-hidden
      style={{
        position: "absolute",
        width: ARROW_WIDTH,
        height: ARROW_HEIGHT,
        left: arrowX != null ? `${arrowX}px` : "",
        top: arrowY != null ? `${arrowY}px` : "",
        bottom: "100%",
        marginTop: 1,
      }}
    >
      <span className="fuel-tooltip__arrow-outer" />
      <span className="fuel-tooltip__arrow-inner" />
    </div>
  );
});

TooltipArrowBottom.displayName = "TooltipArrowBottom";

export default TooltipArrowBottom;
